import React from "react"

const stateValues: { [K in GlobalStateName]?: GlobalState[K] } = {}
const stateSubscribes: GlobalStateSubscribe<any>[] = []

export function getGlobalstate<N extends GlobalStateName>(name: N): GlobalState[N] | undefined {
    return stateValues[name]
}

export function setGlobalState<N extends GlobalStateName>(name: N, data: GlobalState[N]) {
    stateValues[name] = data

    for (const sub of stateSubscribes) {
        if (sub.stateName === name) {
            sub.callback(data)
        }
    }
}

export function SubscribeGlobalState<N extends GlobalStateName>(name: N): GlobalState[N] | undefined {
    const [data, setData] = React.useState<GlobalState[N] | undefined>(stateValues[name])
    React.useEffect(() => subscribeGlobalStateHadler(name, d => {
        setData(d)
    }), [name])

    return data
}

export function OnClickOutside(ref: React.MutableRefObject<HTMLElement | null>, func: () => void) {
    React.useEffect(
        () => {
            const listener = (event: TouchEvent | MouseEvent) => {
                if (!ref.current || ref.current.contains(event.target as HTMLElement)) {
                    return
                }

                func()
            }

            document.addEventListener("mousedown", listener)
            document.addEventListener("touchstart", listener)

            return () => {
                document.removeEventListener("mousedown", listener)
                document.removeEventListener("touchstart", listener)
            }
        },
        [ref, func]
    )
}

export function OnChangeLocation(func: () => void) {
	React.useEffect(
		() => {
			func();
		},
		[window.location.href]
	)
}

function subscribeGlobalStateHadler<N extends keyof GlobalState>(name: N,
    callback: (data: GlobalState[N] | undefined) => void): () => void {
    const sub: GlobalStateSubscribe<N> = {
        stateName: name,
        callback
    }
    stateSubscribes.push(sub)

    callback(stateValues[name])

    return () => stateSubscribes.splice(stateSubscribes.indexOf(sub), 1)
}